import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName IVR Template
 */

export default function IvrTemplateFillIcon(props) {
  return (
    <Icon viewBox="0 0 49 47" {...props}>
      <mask height="47" id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" width="49" x="0" y="0">
        <rect height="47" rx="8" width="49" />
      </mask>
      <g clipRule="evenodd" fillRule="nonzero" mask="url(#mask0)">
        <path
          d="M18 12V15M18 15H24C24.5523 15 25 15.4477 25 16V29.5C25 30.0523 25.4477 30.5 26 30.5H48M18 15H12C11.4477 15 11 15.4477 11 16V18"
          fill="none"
        />
        <rect height="7" rx="2" width="10" x="13" y="6" />
        <rect height="7" rx="2" width="10" x="20" y="17" />
        <rect height="7" rx="2" width="10" x="20" y="27" />
        <rect height="7" rx="2" width="10" x="33" y="27" />
        <rect height="7" rx="2" width="10" x="46" y="27" />
        <rect height="7" rx="2" width="10" x="7" y="17" />
      </g>
    </Icon>
  );
}
